// import { DealIcon } from '@/shared/components/icons/DealIcon'
// import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatDate } from '@/shared/lib/date'
import { ColumnDef } from '@tanstack/react-table'
import { MessageModel } from '../types/MessageTypes'
import { MessageStatus } from '../ui/MessageStatus/MessageStatus'

export const columns: ColumnDef<MessageModel>[] = [
  {
    accessorKey: 'createdAt',
    header: 'Дата и время',
    cell: ({ row }) => {
      const formattedDate = formatDate(row.original.createdAt)
      return <span className="font-klein font-medium">{formattedDate}</span>
    },
  },
  {
    accessorKey: 'message',
    header: 'Текст',
    cell: ({ row }) => {
      const rawMessage = row.original.message
      let parsed: { From?: string; Message?: string } = {}
      parsed = JSON.parse(rawMessage)

      return (
        <div className="flex flex-col">
          <span className="font-klein font-medium">От {parsed.From || '—'}</span>
          <span className="text-text-secondary">{parsed.Message || 'Нет данных'}</span>
        </div>
      )
    },
  },
  {
    accessorKey: 'status',
    header: 'Статус',
    cell: () => {
      return <MessageStatus status="recognized" />
    },
  },
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ row }) => {
      return (
        <span className="text-primary dark:text-primary-dark text-base">{row.original.id}</span>
      )
    },
  },
  // {
  //   accessorKey: 'deal',
  //   header: 'Сделка',
  //   cell: () => {
  //     return (
  //       <ItemLayout
  //         icon={<DealIcon status="grey" />}
  //         subtitle={'11 апреля 2024 г. в 14:38'}
  //         title={'Платеж выполняется'}
  //       />
  //     )
  //   },
  // },
  // {
  //   accessorKey: 'dealAmount',
  //   header: 'Сумма сделки',
  //   cell: () => (

  //     <div className="flex flex-col">
  //       <span>{}</span>
  //       <span className="text-text-secondary">{formatterRubWitCurrency.format(0)}</span>
  //     </div>
  //   ),
  // },
]
